import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileMentorsSection from '/component/partial/profile/ProfileMentorsSection';
import {withTranslation} from '/provider/TranslationProvider';
import {teamsMentorsById} from '/redux/selector/coach.selector';

const Mentors = connect(
  createStructuredSelector({
    mentors: teamsMentorsById,
  }),
)(ProfileMentorsSection);

export default withTranslation('screen.coachTeams.section.mentors')(Mentors);
